import { render, staticRenderFns } from "./work-history-detail.vue?vue&type=template&id=2b41b340&scoped=true"
import script from "./work-history-detail.vue?vue&type=script&lang=js"
export * from "./work-history-detail.vue?vue&type=script&lang=js"
import style0 from "./work-history-detail.vue?vue&type=style&index=0&id=2b41b340&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b41b340",
  null
  
)

export default component.exports